import Moment from 'moment';

export const ConvertDateTime=(value:any,format:string)=>{
    if(value)
     return Moment(value).format(format);

 return '';
}

